module.exports = __webpack_public_path__ + "static/media/crow_try_to_pick_roti.c529a602.png";